import { FC, memo } from "react";
import InfoField from "../../../../../components/Common/InfoField";
import { TWorkSession } from "../../../../../common/types";

interface WorkSessionNotesProps {
    data?: TWorkSession['workingSessionNotes'];
}

const WorkSessionNotes: FC<WorkSessionNotesProps> = ({ data }) => data?.map(({ id, detail}, index) => (
    index == 0 && <InfoField
        key={`work-session-note-${id}`}
        title="Operator Note"
        value={detail}
    />
));

export default memo(WorkSessionNotes);
